import { isProdEnvIndeed } from '../environment';

const ENABLE_MAP = {
  reddit: false,
};

const triggerSignUpConversion = () => {
  if ((window as any).rdt) {
    (window as any).rdt('track', 'SignUp');
  }
};

export const initReddit = (force = false) => {
  if (isProdEnvIndeed() || force) {
    ENABLE_MAP.reddit = true;
  }
};

export const triggerRedditSignUpConversion = () => {
  if (ENABLE_MAP.reddit) {
    triggerSignUpConversion();
  }
};


